import { EprInfoDto } from 'types/dtos/epr'

import { api } from './api'

export const addEprInfo = (eprInfo: EprInfoDto) => api.post('/business_accounts/epr_uins', eprInfo)
